import validate from 'validate.js';

validate.validators.presence.options = {message: 'form.required'};
validate.validators.email.options = {
  message: 'form.email-valid',
};
validate.validators.length.options = {
  message: 'form.year-lenght',
};
validate.validators.numericality.options = {
  message: 'form.number-valid',
};

export const required = (value) =>
  value === false
    ? validate.validators.presence.options.message
    : validate.single(value, {
        presence: {
          allowEmpty: false,
        },
      });

export const requiredEmail = (value) =>
  validate.single(value, {
    email: true,
    presence: {
      allowEmpty: false,
    },
  });

export const requireBirthDate = (value) =>
  value === false
    ? validate.validators.presence.options.message
    : validate.single(value, {
        length: {is: 4},
        numericality: {
          greaterThanOrEqualTo: 1900,
          lessThanOrEqualTo: new Date(Date.now()).getFullYear() - 10,
        },
        presence: {
          allowEmpty: false,
        },
      });
